<template>
  <div class="main-content-container">
    <b-row>
        <b-col cols="12">
          <h1 class="font-lg font-family-medium primary-dark content-title">
            Search Results for "{{ $route.query.q }}"
          </h1>
        </b-col>
    </b-row>

    <b-tabs
      v-model="tabIndex"
      class="customer-details-tabs"
      style="height:80%"
      active-nav-item-class="danger"
      active-tab-class="text-success"
    >
      <b-tab title="Tasks" style="height:100%">
        <TaskDashboard searchMode/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import TaskDashboard from "@/views/common/assistant/tasks/PATasks"

import { mapState } from "vuex";
export default {
  name: "Search",
  components: {
    TaskDashboard,
  },
  computed: {
    ...mapState("authModule", ["role"])
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('clearSearchBox', {})
    next()
  },
  data() {
    return {
      tabIndex: 0,
      customerID: "",
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.user-info-right {
  justify-content: flex-end;
}
.user-info-right-container {
  right: 8rem;
}
.user-info-right-container-skeleton {
  right: 18rem;
}
.user-info-content {
  left: 2rem;
}
.vertical-border {
  border-left: 1px solid rgb(132 155 165 / 0.2);
  right: 1rem;
}
.tab-content {
  height: 90%;
}

@media screen and (max-width: 991px) {
  .user-info-right.customer-details-user-info {
    justify-content: flex-start;
  }
  .user-info-right-container {
    right: 0;
  }
}
</style>
